/* Across Site */
$(".ellipsis").ellipsis(true);
$("a[rel^='prettyPhoto']").prettyPhoto({social_tools:""});

/* Main Menu */
$('ul.sf-menu').supersubs({minWidth:13, maxWidth:27, extraWidth:1}).superfish();

// find first menu href that matches the current page
var menu_a = $('ul.sf-menu a[href="' + location.pathname + '"]:eq(0)');
if (menu_a.length == 0) { // might be in a product/article page, check for a collection/blog
	
}
menu_a.parent().addClass('current');
$(".sub-menu .current").parents('li').addClass('current');

$("#main-menu a[href='/#']").click(function() {
    return false;
})

if (navigator.platform === "iPad") {
    $('a.sf-with-ul').each(function() {
        $(this).attr('data-clicked', 'false');
        $(this).click(function(e) {
            if ($(this).attr('data-clicked') === 'false') {
                e.preventDefault();
                $(this).attr('data-clicked', 'true');
                return false;
            }
            return true;
        })
    })
}

/* Collection Page */
$(".dropdown dt a").click(function(e) {
	$(".dropdown dd ul").hide();
	$(this).parents(".dropdown").find("dd ul").toggle();
	e.preventDefault();
});

$(document).bind('click', function(e) {
	var $clicked = $(e.target);
	if (!$clicked.parents().hasClass("dropdown"))
		$(".dropdown dd ul").hide();
});
			
$(".dropdown dd ul li a").click(function(e) {
	var dd = $(this).parents(".dropdown");
	var text = $(this).html();
	dd.find("dt a").html(text);
	dd.find("dd ul").hide();
});

/* Product Page */
$("#related ul").prettyGallery({itemsPerPage:8});

/* Cart Page */


/* Window Load */
$(window).load(function() {
    $('#slider').nivoSlider({
        pauseTime: 5000,
        effect: 'random',
        pauseOnHover: true
    });
});
